// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__IIzWu","requiredAsterisk":"Info_requiredAsterisk__39lnV"};